import { Breadcrumbs } from '@/components/ui/breadcrumb'
import RebatePoliciesTable from '@/routes/Transactions/RebatePoliciesTable'
import RebateSettingsTable from '@/routes/Transactions/RebateSettingsTable'
import { links } from '@/utils/featureToggles'

const TransactionIBCashbackSettingsOverview = () => {
  const crumbs = [
    {
      title: 'Transactions - IB Cashback Settings',
      link: links.transactionIBCashbackSettings.url,
    },
  ]

  return (
    <>
      <Breadcrumbs crumbs={crumbs} />
      <main>
        <RebatePoliciesTable />
        <RebateSettingsTable />
      </main>
    </>
  )
}

export default TransactionIBCashbackSettingsOverview
